import axios from 'axios'
import config from '@/config'

const recriutingService = {
  searchCandidates(query) {
    console.log('query from api: ', query)
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          config.BASE_API_URL +
          `/profile/candidate/recruitingsearch?count=10&page=${query.page}${
            query.textsearch ? '&textsearch=' + query.textsearch : ''
          }${query.careerstage ? '&careerstage=' + query.careerstage : ''}${
            query.highesteducation ? '&highesteducation=' + query.highesteducation : ''
          }${query.employmenttype ? '&employmenttype=' + query.employmenttype : ''}${
            query.nationality ? '&nationality=' + query.nationality : ''
          }`,
      })
        .then(res => resolve(res))
        .catch(e => {
          reject(e.response)
        })
    })
  },
  performLike(email) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + '/profile/candidate/recruitingsearch/favorite/add',
        data: { candidateEmail: email },
      })
        .then(res => resolve(res))
        .catch(e => {
          reject(e.response)
        })
    })
  },
  performDislike(email) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: config.BASE_API_URL + '/profile/candidate/recruitingsearch/favorite/remove',
        data: { candidateEmail: email },
      })
        .then(res => resolve(res))
        .catch(e => {
          reject(e.response)
        })
    })
  },
  getFavorites() {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: config.BASE_API_URL + '/profile/candidate/recruitingsearch/favorite/list',
      })
        .then(res => {
          resolve(res)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  createSubscription(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_LOGIN_URL + `/rs/subscription/create`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  updateSubscription(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_LOGIN_URL + `/rs/subscription/update/status`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  cancelSubscription(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_LOGIN_URL + `/rs/subscription/cancel`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  suspendSubscription(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        data: data,
        url: config.BASE_API_LOGIN_URL + `/rs/subscription/suspend`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  verifyVoucher(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        data: data,
        url: config.BASE_API_LOGIN_URL + `/rs/subscription/voucher?voucherNo=${data.voucherNo}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
  fetchSubscriptionDetail(context, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        data: data,
        url: config.BASE_API_LOGIN_URL + `/rs/subscription/details?subscriptionId=${data.subscriptionId}`,
      })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e.response)
        })
    })
  },
}

export default recriutingService
